import HasAccess from 'modules/AccessControl/hasAccess';
import PERMISSIONS from '_constants/PERMISSIONS';

/**
 * Whether the media tagging feature is available to this account at all.
 *
 * `media_tags` is an account module, so it arrives in `modularity_permissions` — HasAccess checks the
 * role permissions, the modularity permissions and the account modules as one pool, so a single call
 * covers it. Without the module NOTHING tag-related is rendered: no chips, no "+ Tag", no tag filter,
 * no bulk actions, and the image preview falls back to the plain modal (see MediaLightbox).
 *
 * Distinct from the two role permissions layered on top of the module:
 *   assign_media_tags (useMediaTagsAssign) — apply/remove existing tags on media;
 *   manage_media_tags (useTagManage → `canManage`) — create/rename/delete the vocabulary
 *   (does NOT imply assigning — the two are independent).
 * With the module alone, tag UI is READ-ONLY: chips and the tag filter render, every write surface
 * (the "+ Tag" pickers, chip removal, bulk actions, the review workstation) is hidden.
 */
const useMediaTagsAccess = () => HasAccess(PERMISSIONS.MEDIA_TAGS);

export default useMediaTagsAccess;
